import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      "fill-rule": "evenodd",
      d: "M8 .2a.8.8 0 0 1 .8.8v6.2H15a.8.8 0 0 1 0 1.6H8.8V15a.8.8 0 0 1-1.6 0V8.8H1a.8.8 0 0 1 0-1.6h6.2V1A.8.8 0 0 1 8 .2",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }